// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"79a6639d","29":"bdae74c7","264":"61da5a27","472":"bd79ff53","685":"f1a8d032","867":"b8c53be3"}[chunkId] + ".chunk.css";
};